/* eslint-disable no-case-declarations */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import editSettingActions, {
    editSettingTypes,
} from '../../../redux/settings/editSetting'
import getSettingActions from '../../../redux/settings/getSetting'
import { Put } from '../../../serveur/axios'

function* editSettingSagas({ response }) {
    try {
        const res = yield Put(`delais/${response.id}`, response)

        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(editSettingActions.editSettingSuccess(res.data)),
                yield put(getSettingActions.getSettingRequest()),
            ])
        } else {
            yield put(editSettingActions.editSettingFailure(res.data))
        }
    } catch (error) {
        yield put(editSettingActions.editSettingFailure(error))
    }
}

export function* editSettingSaga() {
    yield takeLatest(editSettingTypes.EDIT_SETTING_REQUEST, editSettingSagas)
}
